function getSkillName(skill) {
  if (!skill || typeof skill !== 'object') {
    return ''
  }

  if (typeof skill.display_name === 'string' && skill.display_name.trim() !== '') {
    return skill.display_name.trim()
  }

  return typeof skill.name === 'string' ? skill.name.trim() : ''
}

function getParentSkillName(skill) {
  if (!skill || typeof skill !== 'object') {
    return ''
  }

  if (typeof skill.parent_name === 'string' && skill.parent_name.trim() !== '') {
    return skill.parent_name.trim()
  }

  const parentName = skill.parent && typeof skill.parent === 'object' ? skill.parent.name : ''
  return typeof parentName === 'string' ? parentName.trim() : ''
}

export function hasCharacterSkill(skills = [], skillName = '') {
  const targetName = typeof skillName === 'string' ? skillName.trim() : ''

  if (!targetName || !Array.isArray(skills)) {
    return false
  }

  return skills.some((skill) => getSkillName(skill) === targetName)
}

export function findDependentCharacterSkills(skills = [], rootSkill = null) {
  if (!Array.isArray(skills) || !rootSkill) {
    return []
  }

  const rootName = getSkillName(rootSkill)

  if (!rootName) {
    return []
  }

  const remainingSkills = [...skills]
  const pendingParentNames = [rootName]
  const dependentSkills = []
  const seenKeys = new Set([`${rootSkill.id ?? ''}:${rootName}`])

  while (pendingParentNames.length > 0) {
    const currentParentName = pendingParentNames.shift()

    remainingSkills.forEach((candidate) => {
      const candidateName = getSkillName(candidate)
      const candidateParentName = getParentSkillName(candidate)
      const candidateKey = `${candidate.id ?? ''}:${candidateName}`

      if (!candidateName || seenKeys.has(candidateKey)) {
        return
      }

      if (candidateParentName === currentParentName) {
        dependentSkills.push(candidate)
        pendingParentNames.push(candidateName)
        seenKeys.add(candidateKey)
      }
    })
  }

  return dependentSkills
}

export function getMissingParentSkillMessage({
  characterName = '',
  staticSkill = null,
  skills = [],
  deletedSkillNames = [],
} = {}) {
  const skillName = getSkillName(staticSkill)
  const parentSkillName = getParentSkillName(staticSkill)
  const pendingDeletes = new Set(
    Array.isArray(deletedSkillNames)
      ? deletedSkillNames
          .map((name) => (typeof name === 'string' ? name.trim() : ''))
          .filter(Boolean)
      : [],
  )

  if (!skillName || !parentSkillName) {
    return ''
  }

  if (pendingDeletes.has(parentSkillName)) {
    return `Cannot save '${skillName}' because parent skill '${parentSkillName}' is also being deleted.`
  }

  if (!hasCharacterSkill(skills, parentSkillName)) {
    const suffix = characterName ? ` for character '${characterName}'.` : '.'
    return `Cannot save '${skillName}' because parent skill '${parentSkillName}' is missing${suffix}`
  }

  return ''
}
